// extracted by mini-css-extract-plugin
module.exports = {"content":"content-69cfbc9cb63e4a98e0d7f02ae41bed8f"};